import { ComposeViewState, getStore } from 'owa-mail-compose-store';
import ensureComposeTabHandler from '../utils/composeTabHandler';
import { TabType, lazyAddTab, lazyActivateTab } from 'owa-tab-store';
import { action } from 'satcheljs/lib/legacy';
import { findTabByData, lazySetTabIsShown } from 'owa-tab-store';

export default action('moveComposeToTab')(async function(
    viewState: ComposeViewState,
    isShown: boolean,
    makeActive: boolean
) {
    const composeId = viewState.composeId;
    const tab = findTabByData(composeId);
    if (tab) {
        if (makeActive) {
            lazyActivateTab.importAndExecute(tab);
        } else {
            lazySetTabIsShown.importAndExecute(tab, isShown);
        }
    } else {
        const store = getStore();
        if (store.primaryComposeId == composeId) {
            store.primaryComposeId = null;
        }

        ensureComposeTabHandler();
        await lazyAddTab.importAndExecute(
            TabType.Compose,
            isShown /*isShown*/,
            makeActive,
            composeId
        );
    }
});
